var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sheader"},[_c('h2',{staticClass:"heading-tertiary"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('ToolBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }